'use strict';

var _ = require('lodash');
var PricingAnalysisCommonsDataService = function PricingAnalysisCommonsDataService(restangular, $q, MomentService, dataRetrieverService, currentStateCriteriaService, SearchCriteriaRule, legendFilterService, configurationService, BenchmarkService) {
  var hepService = restangular.one('configuration').one('hep');
  var priceRecommendationDepartureDateRetriever;
  var priceRecommendationServicesRetriever;
  var analysisData;
  var servicesData;
  function getPriceRecommendationDepartureDateRetriever() {
    if (!priceRecommendationDepartureDateRetriever) {
      priceRecommendationDepartureDateRetriever = dataRetrieverService.getDataRetriever('PRICING_ANALYSIS_SCREEN', 'pricing-analysis-departure-dates');
      priceRecommendationDepartureDateRetriever.setCustomSearchCriteriaRules([]);
    }
    return priceRecommendationDepartureDateRetriever;
  }
  function getPriceRecommendationServicesRetriever() {
    if (!priceRecommendationServicesRetriever) {
      priceRecommendationServicesRetriever = dataRetrieverService.getDataRetriever('PRICING_ANALYSIS_SCREEN', 'pricing-analysis-services');
      priceRecommendationServicesRetriever.setCustomSearchCriteriaRules([]);
    }
    return priceRecommendationServicesRetriever;
  }
  function preparePriceRecommendationServiceFilter() {
    return {
      pos: legendFilterService.getSelectedPos(),
      carrier: legendFilterService.getSelectedCarrier(),
      cabinCode: legendFilterService.getSelectedCabin(),
      market: legendFilterService.getSelectedMarket(),
      departureDate: legendFilterService.getSelectedDepartureDate().toISOString(),
      direction: legendFilterService.getSelectedDirection()
    };
  }
  function preparePriceRecommendationServiceSearch(filter) {
    return _.chain(filter).toPairs().map(function (entry) {
      if (entry[0] === 'eventTimeStamp') {
        var lowRange = entry[1].clone().startOf('day');
        var highRange = entry[1].clone().endOf('day');
        return new SearchCriteriaRule({
          operator: 'Between',
          leftOperand: lowRange,
          rightOperand: highRange,
          field: entry[0]
        });
      }
      if (entry[0] === 'effectiveTimeStamp') {
        return new SearchCriteriaRule({
          operator: '<',
          leftOperand: entry[1],
          field: entry[0]
        });
      }
      return new SearchCriteriaRule({
        operator: '=',
        leftOperand: entry[1],
        field: entry[0]
      });
    }).value();
  }
  function retrieveServicesData(rules) {
    rules = rules || [];
    var retriever = getPriceRecommendationServicesRetriever();
    servicesData = retriever.retrieveData('pricing-analysis-services', rules);
    return servicesData;
  }
  function isCurrentEventTimeStampBeforeNow(currentRule) {
    var today = MomentService.now(MomentService.FIELD.OPTIMIZATION_RUN_DATE).startOf('day');
    return currentRule && (currentRule.leftOperand.isBefore(today) || currentRule.leftOperand.isSame(today));
  }
  function addEventTimeStamp(rules, nextProceedDate) {
    var currentRule = _.find(rules, {
      field: 'eventTimeStamp'
    });
    if (isCurrentEventTimeStampBeforeNow(currentRule)) {
      return rules;
    }
    if (currentRule) {
      _.remove(rules, {
        field: 'eventTimeStamp'
      });
    }
    var clonedRules = _.clone(rules);
    clonedRules.push(new SearchCriteriaRule({
      operator: 'Between',
      leftOperand: nextProceedDate.clone().subtract(1, 'day').startOf('day'),
      rightOperand: nextProceedDate.clone().subtract(1, 'day').endOf('day'),
      field: 'eventTimeStamp'
    }));
    return clonedRules;
  }
  function addEffectiveTimeStamp(rules) {
    var currentRule = _.find(rules, {
      field: 'effectiveTimeStamp'
    });
    if (currentRule) {
      return rules;
    }
    var effectiveTimeStamp = MomentService.now(MomentService.FIELD.EFFECTIVE_TIME_STAMP);
    var clonedRules = _.clone(rules);
    clonedRules.push(new SearchCriteriaRule({
      operator: '<',
      leftOperand: effectiveTimeStamp.clone().endOf('day'),
      field: 'effectiveTimeStamp'
    }));
    return clonedRules;
  }
  function retrieveData(nextProceedDate) {
    var retriever = getPriceRecommendationDepartureDateRetriever();
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    var rules = addEventTimeStamp(searchCriteria.rules, nextProceedDate);
    rules = addEffectiveTimeStamp(rules);
    rules = replaceRunNumberRule(rules);
    if (!analysisData) {
      analysisData = retriever.retrieveData('pricing-analysis-departure-dates', rules);
    }
    return analysisData;
  }
  function replaceRunNumberRule(rules) {
    var RUN_NUMBER_FIELD_NAME = 'runNumber';
    var eventTimeStampRule = _.find(rules, {
      field: 'eventTimeStamp'
    });
    var runNumberRule = _.find(rules, {
      field: RUN_NUMBER_FIELD_NAME
    });
    if (!eventTimeStampRule || configurationService.getRecommendedFrequency() <= 1) {
      _.remove(rules, {
        field: RUN_NUMBER_FIELD_NAME
      });
      return rules;
    }
    var newRunNumber = legendFilterService.getSelectedRunNumber();
    var eventTimeStamp = eventTimeStampRule.leftOperand.format(MomentService.FORMAT.YEAR_MONTH_DAY_NOT_SEPARATED);
    if (runNumberRule && !_.isNil(runNumberRule.leftOperand.value) && runNumberRule.leftOperand.value.toString().length === 1) {
      newRunNumber = eventTimeStamp.concat(runNumberRule.leftOperand.value);
      legendFilterService.setSelectedRunNumber(newRunNumber);
    }
    if (newRunNumber) {
      var clonedRules = _.clone(rules);
      _.remove(clonedRules, {
        field: RUN_NUMBER_FIELD_NAME
      });
      clonedRules.push(new SearchCriteriaRule({
        operator: '=',
        leftOperand: newRunNumber,
        field: RUN_NUMBER_FIELD_NAME
      }));
      return clonedRules;
    }
    return rules;
  }
  function retrieveDepartureDatesChartDataBenchmark() {
    return getNextProceedDate().then(function (nextProceedDate) {
      return retrieveData(nextProceedDate);
    });
  }
  function retrieveDepartureDatesChartData() {
    return BenchmarkService.benchmarkPromise('retrieve-departure-date-chart-data', retrieveDepartureDatesChartDataBenchmark);
  }
  function getNextProceedDate() {
    return hepService.get({
      type: 'SystemProperties'
    }).then(function (systemProperties) {
      var nextProcessDate = _.get(systemProperties, ['hepList', 0, 'properties', 'PRICING_EXTRACT_NEXT_PROCESS_DATE']);
      return MomentService.of(nextProcessDate, MomentService.FIELD.HEP_PRICING_EXTRACT_NEXT_PROCESS_DATE);
    });
  }
  function isLatestClass(service) {
    if (!service.originalClass) {
      return true;
    }
    var selectedClass = _.first(service.originalClass.split(','));
    return selectedClass === service.latestClass;
  }
  function retrieveServicesChartDataBenchmark(snapshotDate) {
    var filter = preparePriceRecommendationServiceFilter();
    filter = addSnapshotDateToFilter(filter, snapshotDate);
    filter = addRunNumberToFilter(filter, legendFilterService.getSelectedRunNumber());
    var rules = preparePriceRecommendationServiceSearch(filter);
    return retrieveServicesData(rules).then(function (services) {
      return _.chain(services).thru(function (services) {
        delete filter.eventTimeStamp;
        delete filter.effectiveTimeStamp;
        return services;
      }).filter(filter).filter(function (service) {
        var commonValidation = service.serviceId === service.originalServiceId && _.isNil(service.lengthOfStay);
        if (hasServiceIdClass(services)) {
          return commonValidation && isLatestClass(service);
        }
        return commonValidation && !service.isShownOnUIOnlyForReference;
      }).value();
    });
  }
  function retrieveServicesChartData(snapshotDate) {
    return BenchmarkService.benchmarkPromise('retrieve-services-chart-data', _.partial(retrieveServicesChartDataBenchmark, snapshotDate));
  }
  function prepareTOD(transformedData, lowestCompetitorFareTODSum, servicesNb, compCarriersOutboundTOD, compCarriersInboundTOD, compToLowestTOD) {
    if (!transformedData.isTOD) {
      return;
    }
    transformedData.m4 = _.round(lowestCompetitorFareTODSum / servicesNb, 2);
    transformedData.circles.push({
      value: transformedData.m4,
      css: 'm3-circle'
    });
    transformedData.compCarriersOutboundTOD = _.uniq(compCarriersOutboundTOD);
    transformedData.compCarriersInboundTOD = _.uniq(compCarriersInboundTOD);
    transformedData.compToLowestTOD = _.uniqBy(compToLowestTOD, function (obj) {
      return obj.compCarrier + obj.flightNbrs + obj.direction;
    });
  }
  function addSnapshotDateToFilter(filter, snapshotDate) {
    if (snapshotDate) {
      filter.eventTimeStamp = snapshotDate;
      filter.effectiveTimeStamp = MomentService.now(MomentService.FIELD.DEPARTURE_DATE).endOf('day');
    }
    return filter;
  }
  function addRunNumberToFilter(filter, runNumber) {
    if (runNumber && configurationService.getRecommendedFrequency() > 1) {
      filter.runNumber = runNumber;
    }
    return filter;
  }
  function hasServiceIdClass(services) {
    var service = _.first(services);
    return service.serviceIdWithClass && (service.isOneWay || service.referenceServiceIdWithClass);
  }
  function retrieveLengthOfStayDataBenchmark(selectedService, withSelected, snapshotDate) {
    var filter = preparePriceRecommendationServiceFilter();
    filter = addSnapshotDateToFilter(filter, snapshotDate);
    filter = addRunNumberToFilter(filter, legendFilterService.getSelectedRunNumber());
    var rules = preparePriceRecommendationServiceSearch(filter);
    return retrieveServicesData(rules).then(function (services) {
      return hasServiceIdClass(services) ? filterServicesWithServiceIdClass(services, selectedService) : legacyFilterServices(services, selectedService, withSelected);
    });
  }
  function retrieveLengthOfStayData(selectedService, withSelected, snapshotDate) {
    return BenchmarkService.benchmarkPromise('retrieve-length-of-stay-data', _.partial(retrieveLengthOfStayDataBenchmark, selectedService, withSelected, snapshotDate));
  }
  function filterServicesWithServiceIdClass(services, selectedService) {
    return _.filter(services, function (service) {
      var hasMatchingClass = service.referenceServiceIdWithClass === selectedService.serviceIdWithClass || service.serviceIdWithClass === selectedService.serviceIdWithClass;
      return hasMatchingClass;
    });
  }
  function filterServicesThatMatchLatestClass(services) {
    if (services.length > 2 && _.some(services, ['direction', 'INBOUND']) && _.some(services, ['direction', 'OUTBOUND'])) {
      var priceRecommendationServiceFilter = preparePriceRecommendationServiceFilter();
      return _.filter(services, function (service) {
        return isLatestClass(service) || service.direction != priceRecommendationServiceFilter.direction;
      });
    }
    return services;
  }

  /**
   * This Method is only for to support old filter strategy and should be deleted soon
   * @deprecated
   * @param services PRDDServices[] : Return PRDD Services From Selected Departure Date
   * @param selectedService PRDDService : Selected Service from services chart in order to bring revert direction services.
   * @param withSelected Boolean : Used to bring selected service itself.
   */
  function legacyFilterServices(services, selectedService, withSelected) {
    var filteredServices = _.chain(services).filter(_.overSome([_.partial(isSelectedService, withSelected, selectedService.key), _.partial(isReferenceService, selectedService)])).uniqBy(function (el) {
      return el.serviceId + el.referenceServiceId + el.departureDate + el.shoppingRecordId;
    }).value();
    return filterByServiceClass(selectedService, filteredServices);
  }
  function filterByServiceClass(originalService, services) {
    var availableClassesByServices = getAvailableClassesByServices(services);
    if (!isMultipleClasses(availableClassesByServices)) {
      return services;
    }
    var filterServices = _.transform(availableClassesByServices, function (result, availableClasses, serviceKey) {
      var serviceKeyData = serviceKey.split(':');
      _.each(services, function (service) {
        if (service.serviceId === serviceKeyData[0] && service.direction === serviceKeyData[1] && service.originalClass !== originalService.originalClass) {
          result.push([service.serviceId, service.originalClass].join(':'));
        }
      });
      return result;
    }, []);
    return _.filter(services, function (service) {
      return !_.includes(filterServices, [service.serviceId, service.originalClass].join(':'));
    });
  }
  function isMultipleClasses(availableServiceClasses) {
    return _.some(availableServiceClasses, function (classes) {
      return _.size(classes) > 1;
    });
  }
  function getAvailableClassesKey(service) {
    return [service.serviceId, service.direction].join(':');
  }
  function getAvailableClassesByServices(services) {
    return _.chain(services).groupBy(function (service) {
      return getAvailableClassesKey(service);
    }).reduce(function (result, data, serviceId) {
      result[serviceId] = _.chain(data).map('originalClass').uniq().value();
      return result;
    }, {}).pickBy(function (classes) {
      return _.size(classes) > 1;
    }).value();
  }
  function invalidateCache() {
    priceRecommendationDepartureDateRetriever = undefined;
    priceRecommendationServicesRetriever = undefined;
    analysisData = undefined;
  }
  function isReferenceService(selectedService, service) {
    return selectedService.referenceServiceIds.indexOf(service.serviceId) !== -1 && service.referenceServiceId === selectedService.serviceId && _.includes(selectedService.shoppingRecordsIds, service.shoppingRecordId) && service.direction === selectedService.revertedDirection && !_.isNil(service.lengthOfStay);
  }
  function isSelectedService(includeSelectedService, selectedKey, service) {
    return includeSelectedService && service.key === selectedKey;
  }
  function isSingleItinerary(service) {
    return service.isOneWay || service.isUniquePresence;
  }
  function getLatestService(groupedData) {
    if (checkAllServicesHavingSameOptimizationTime(groupedData)) {
      return _.chain(groupedData).sortBy('effectiveFareChange').last().value();
    }
    return _.chain(groupedData).sortBy(function (item) {
      return item.initialOptimizationTime.toISOString();
    }).last().value();
  }
  function checkAllServicesHavingSameOptimizationTime(groupedData) {
    return _.chain(groupedData).map('initialOptimizationTime').uniq().value().length === 1;
  }
  return {
    retrieveDepartureDatesChartData: retrieveDepartureDatesChartData,
    retrieveLengthOfStayData: retrieveLengthOfStayData,
    retrieveServicesChartData: retrieveServicesChartData,
    filterServicesThatMatchLatestClass: filterServicesThatMatchLatestClass,
    invalidateCache: invalidateCache,
    prepareTOD: prepareTOD,
    isSingleItinerary: isSingleItinerary,
    getLatestService: getLatestService
  };
};
PricingAnalysisCommonsDataService.$inject = ['Restangular', '$q', 'MomentService', 'DataRetrieverService', 'CurrentStateCriteriaService', 'SearchCriteriaRuleFactory', 'PricingDepartureDatesLegendFilterService', 'ConfigurationService', 'BenchmarkService'];
module.exports = PricingAnalysisCommonsDataService;